<template>
  <div class="publicItems">
    <div class="selectionArea search_box">
      <!-- <el-select v-model="query.platform_id" style="margin-right:10px; margin-top:5px" filterable placeholder="请选择平台" @change="getofflist()"> -->
      <el-select v-model="query.platform_id" filterable placeholder="请选择平台">
        <el-option
          v-for="item in accoutarr"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <!-- <el-select v-model="query.app_id" style="margin-right:10px; margin-top:5px" filterable placeholder="请选择公众号">
          <el-option
            v-for="item in platformSelectList"
            :key="item.id"
            :label="item.account_name"
            :value="item.app_id"
          />
          <div v-if="gzhtotal>10" class="previous" @click="previousPage">上一页</div>
          <div v-if="platformSelectList.length==10&&gzhtotal>10" class="next" @click="nextPage">下一页</div>
        </el-select> -->
      <!--
        <el-autocomplete
          v-model="accountList.value"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入主公众号"
          :clearable="true"
          @clear="(accountList.value = null),(accountList.address = null),(parameter.master_app_id = null)"
          @select="handleSelect"
        /> -->
      <!-- <el-autocomplete
          v-model="accountList.value"
          :fetch-suggestions="getofflist"
          placeholder="请输入公众号名称或app_id"
          :clearable="true"
          @clear="(query.app_id = null)"
          @select="handleSelect"
        /> -->
      <div class="idBox" @click="showTip">
        <el-input v-model="query.keywords" placeholder="请输入公众号名称或app_id" style="min-width: 230px;" @change="getofflist()" @focus="showTip()" @blur="Tip()" />

        <span v-if="showtip" class="sp" @click="showtip=false">{{ query.keywords }}</span>
      </div>

      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />

      <div v-if="query.platform_id==null || query.app_id==null || date.length<1">
        <el-button style="" type="primary" icon="el-icon-search" @click="searchmessage">搜索</el-button>
      </div>
      <el-button v-else style="" type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button style="margin-right:10px" type="info" icon="el-icon-refresh-left" @click="reset">重置</el-button>
    </div>
    <div>
      <h5>温馨提示：请先选择平台，在选择平台对应的公众号以及时间段进行搜索</h5>
    </div>
    <div>
      <el-table
        style="width: 100%"
        :data="tableData.list"
      >
        <el-table-column
          prop="st_date"
          label="日期"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <div>{{ dateConvert(scope.row.st_date) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="当日新增"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <div>注册人数&nbsp;&nbsp;&nbsp;&nbsp;{{ scope.row.today_register }}</div>
            <div>充值人数&nbsp;&nbsp;&nbsp;&nbsp;{{ scope.row.today_charge_people }}</div>
            <div>充值金额&nbsp;&nbsp;&nbsp;&nbsp;{{ scope.row.today_charge_amount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="复充数据" align="center">
          <el-table-column
            label="复充指标"
            align="center"
            min-width="120"
          >
            <template>
              <div>一充人数(率)</div>
              <div>二充人数(率)</div>
              <div>三充人数(率)</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="当天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==1">{{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第二天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <!-- <div v-for="(data,ind) in scope.row.charge_for_days" :key="ind"> -->
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==2">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第三天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==3">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第四天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==4">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第五天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==5">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第六天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==6">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第七天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==7">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第八天"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==8">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第九天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==9">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==10">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十一天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==11">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十二天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==12">
                    {{ detail.count }}({{ detail.cr }}%)</div>
                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十三天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==13">
                    {{ detail.count }}({{ detail.cr }}%)</div>

                </div>
              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十四天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==14">
                    {{ detail.count }}({{ detail.cr }}%)</div>

                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十五天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==15">
                    {{ detail.count }}({{ detail.cr }}%)</div>

                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十六天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==16">
                    {{ detail.count }}({{ detail.cr }}%)</div>

                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十七天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==17">
                    {{ detail.count }}({{ detail.cr }}%)</div>

                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十八天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==18">
                    {{ detail.count }}({{ detail.cr }}%)</div>

                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第十九天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==19">
                    {{ detail.count }}({{ detail.cr }}%)</div>

                </div>

              </div>

            </template>

          </el-table-column>
          <el-table-column
            prop="charge_for_days"
            label="第二十天"
            align="center"
            min-width="120"
          >

            <template slot-scope="scope">
              <div v-for="(data,ind) in JSON.parse(JSON.stringify(scope.row.charge_for_days)).sort(compare('times'))" :key="ind">
                <div v-for="(detail,index) in data.details" :key="index">
                  <div v-if="detail.day==20">
                    {{ detail.count }}({{ detail.cr }}%)
                  </div>

                </div>

              </div>

            </template>

          </el-table-column>

        </el-table-column>

      </el-table>
    </div>

    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { officialAccountlist, strategyPlatform } from '@/api/sourceMaterial.js'
import { getladderdiagramList } from '@/api/ladderdiagram.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      loading: false,
      // 分页信息
      query: {
        keywords: null,
        account_name: null,
        status: null,
        page: 1,
        pageSize: 10,
        platform_id: null,
        operation_status: null,
        basic_account: null,
        onlyMe: 2,
        app_id: null
      },
      activeItem: null,
      activeText: null,
      date: [],
      accountList: {}, // 主公众号
      platformSelectList: [], // 平台列表
      accoutarr: [],
      gzhtotal: 0,
      input: '',
      showtip: false
    }
  },
  created() {
    this.getstrategyplatform()
    // this.getofflist()
  },

  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getladderdiagramList(
        {
          page: this.query.page,
          platform_id: this.query.platform_id,
          app_id: this.query.app_id,
          page_size: this.query.pageSize,
          register_from: this.date[0].replace(/[-]/g, ''),
          register_to: this.date[1].replace(/[-]/g, '')
        }
      )
      this.tableData = data.data
      console.log('tableData-----', this.tableData)
      this.loading = false
    },
    // 搜索
    searchclick() {
      this.query.page = 1
      this.getDataList()
    },
    // 重置

    reset() {
      this.query = {
        keywords: null,
        account_name: null,
        status: null,
        page: 1,
        pageSize: 10,
        platform_id: null,
        operation_status: null,
        basic_account: null,
        onlyMe: 2
      }
      this.date = []
      this.tableData = []
      this.accountList = {}
      this.getstrategyplatform()
    },

    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },
    // 获取对应平台公众号
    async getofflist(cb) {
      this.loadingtable = true
      const data = await officialAccountlist({
        page: this.query.page,
        pageSize: this.query.pageSize,
        // platform_id: this.query.platform_id,
        keywords: this.query.keywords,
        onlyMe: this.query.onlyMe
      })
      this.gzhtotal = data.data.total
      console.log('this.gzhtotal', data.data.list)
      this.platformSelectList = data.data.list
      this.query.app_id = data.data.list[0].app_id

      // this.app_id = data.data.list.app_id
      // data.data.list.map((item) => {
      //   this.app_id = item.app_id
      // })
      // cb(news)
    },
    handleSelect(item) {
      console.log('handleSelect', item)
      this.accountList = item
      this.query.app_id = item.address
    },
    // 分页
    fetchPageSize(s) {
      this.query.pageSize = s
      this.getDataList()
    },
    // 公众号选择

    // 分页
    fetchCurrentPage(s) {
      this.query.page = s
      this.getDataList()
    },
    // 公众号  下一页
    // nextPage() {
    //   this.query.page += 1
    //   this.getofflist()
    // },
    // // 公众号  上一页
    // previousPage() {
    //   if (this.query.page > 1) {
    //     console.log('上一页')
    //     this.query.page -= 1
    //     this.getofflist()
    //   }
    // },
    compare(property) {
      return function(a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    dateConvert(dates) {
      return dates.toString().replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
    },
    searchmessage() {
      console.log('搜索内容不完整')
      this.$message({
        showClose: true,
        message: '请将平台、公众号以及日期补充完整在进行搜索！',
        type: 'warning'
      })
    },
    showTip() {
      // if (this.query.keywords.length > 0) {
      this.showtip = true
      // }
    },
    Tip() {
      this.showtip = false
    }
  }
}

</script>

  <style scoped lang="less">
  .content{
     .item{
       display: flex;
       align-items: center;
      .item_title{
         display: inline-block;
         width: 100px;
      }
      .item_input{
         width: 200px
      }
     }
  }
  .publicItems{
    width: 95%;
    margin: 0 auto;
    margin-top: 30px;

  }

  .publicItems .selectionArea{
      margin-bottom: 20px;
  }
  .selectionArea{
    display: flex;
    flex-wrap: wrap;
    .item{
      display: flex;
      align-items: center;
      margin-right: 20px;
      margin-bottom: 10px;
      .item_title{
         margin-right: 10px;
         display: inline-block;
      }
      .item_input{
        width:200px
      }
    }
  }
  .icon_box{
    display:flex;
    justify-content: center;
  }
  .icon{
      font-weight: bold;
      font-size: 130%;
  }

  </style>

  <style>
  .publicItems .el-dialog{
    margin-top: 6vh !important;
  }
  .content1{
    padding: 13px;
    color: #000;
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;
  }
  .content1>div:nth-child(1){
    margin-right: 7rem;
  }
  .content1>div{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 7rem;
  }
  .content1>div>div:nth-child(2){
    color: rgb(194, 12, 12);
  }
  .previous{
    width: 35%;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    text-align: center;
    border:1px solid #ccc;
    float: left;
    border-radius: 5px;
    margin-left: 5px;
  }
  .next{
    width: 35%;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    text-align: center;
    border:1px solid #ccc;
    float: right;
    border-radius: 5px;
    margin-right: 5px;
  }
  .idBox{
    position: relative;
  }
  .sp{
    line-height: 40px;
   /* padding: 10px 0; */
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    text-align: center;
    border: 1px solid #e4e3e3;
    background-color: #fff;
    border-radius: 5px;
  }
  @media (max-width: 768px){
    .idBox{
      width:100%
    }
  }

  </style>

